var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"price text-no-wrap"},[_vm._v("$ "+_vm._s(_vm.formatted)+" "),(_vm.showGst)?_c('small',[_vm._v(" + GST")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }